import { MatcherAnswers } from '../flow/types';

export interface MatcherFormData {
  matcherAnswers: MatcherAnswers;
}

export function initialMatcherForm(): MatcherFormData {
  return {
    matcherAnswers: {}
  };
}
